<template>
  <!-- Default avatar icon: generic person silhouette placeholder -->
  <svg viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="192" height="192" fill="var(--color-accent-primary)" />
    <path
      d="M119.333 126V119.333C119.333 115.797 117.929 112.406 115.428 109.905C112.928 107.405 109.536 106 106 106H86C82.4637 106 79.0724 107.405 76.5719 109.905C74.0714 112.406 72.6666 115.797 72.6666 119.333V126"
      stroke="var(--color-text-black-white)"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M96 92.6667C103.364 92.6667 109.333 86.6971 109.333 79.3333C109.333 71.9695 103.364 66 96 66C88.6362 66 82.6666 71.9695 82.6666 79.3333C82.6666 86.6971 88.6362 92.6667 96 92.6667Z"
      stroke="var(--color-text-black-white)"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
